module.exports = __webpack_public_path__ + "img/switchOff2x.png?11ccefcb2f6b26b62a2c61f0447b6803";